/**
 * The one set of user-facing strings in this package that is deliberately NOT
 * localized: they are shown when the resource pack itself could not be fetched,
 * so there is no bundle for `t()` to resolve against — routing them through it
 * would throw `Resource does not exist` from inside the error path meant to
 * report that failure, leaving a blank page.
 *
 * Hardcoded at the source locale (`en-US`), matching `DEFAULT_LOCALE`. Keep this
 * list minimal: anything that can be shown while a bundle exists belongs in
 * `strings.puff.json`. See the failure-mode table in
 * `.agents/planning/2026-10-12-panther-localization/design/design.md` §6.
 */
export const BUNDLE_FAILURE_STRINGS = {
  header: 'LangHub could not finish loading',
  body:
    'The display text for this page could not be loaded. This is usually ' +
    'temporary — reload to try again. If it keeps happening, report it to the ' +
    'LangHub team.',
  reload: 'Reload',
  errorIconAria: 'Error',
} as const;
